import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../../theming/useTheme';
import { OptionalAdditionalStyle } from '../../components.utils';
import { AspectRatio } from './image.types';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';

const componentConfigThemeKey = 'imageWrapper';

interface ImageWrapperDataProps {
  aspectRatio: AspectRatio
  dataId?: string
}

interface ImageWrapperThemeProps {
  backgroundColor: string
}

export const getStyle = (aspectRatio: AspectRatio, backgroundColor: string) => StyleSheet.create({
  base: {
    backgroundColor,
    position: 'relative',
    overflow: 'hidden',
    margin: 0,
    boxSizing: 'border-box',
    flex: '1 1 100%',
    minWidth: '0%',
    paddingTop: `calc(100% / (${aspectRatio.x / aspectRatio.y}))`,
  },
});

type ImageWrapperProps = ImageWrapperDataProps & OptionalAdditionalStyle;

export const ImageWrapperComponent: React.FunctionComponent<ImageWrapperProps & ImageWrapperThemeProps> = ({ additionalStyle, aspectRatio, backgroundColor, dataId, children }) => {
  const imageWrapperStyle = getStyle(aspectRatio, backgroundColor);
  return additionalStyle
    ? (
      <figure data-id={dataId} className={css(additionalStyle.style)}>
        <div className={css(imageWrapperStyle.base)}>{children}</div>
      </figure>
    )
    : (
      <figure data-id={dataId} className={css(imageWrapperStyle.base)}>
        {children}
      </figure>
    );
};

const mapThemeProps = (theme: ImageWrapperThemeProps) => {
  return {
    backgroundColor: theme.backgroundColor,
  };
};

export const ImageWrapper: React.FC<ImageWrapperProps> = props => {
  const themeContext = useTheme(componentConfigThemeKey, mapThemeProps);
  return <ErrorBoundary><ImageWrapperComponent {...themeContext} {...props} /></ErrorBoundary>;
};
